import { nanoid as createNanoid } from 'nanoid'
export default function(context) {
  const { router } = context
  const createQueryState = state => {
    const nanoid = createNanoid(10)
    const stateKey = `history__${nanoid}`
    sessionStorage.setItem(stateKey, JSON.stringify(state))
    if (sessionStorage.getItem(stateKey)) {
      return nanoid
    }
    throw new Error('EMAXLIMIT')
  }
  const getQueryState = pNanoid => {
    let queryState = null
    const { query } = router.currentRoute
    const nanoid = pNanoid || query['state']
    if (nanoid) {
      const stateKey = `history__${nanoid}`
      const storeState = sessionStorage.getItem(stateKey)
      if (storeState) {
        queryState = JSON.parse(storeState)
      } else {
        throw new Error('ESTATEEXPIRED')
      }
    } else {
      throw new Error('NOSTATEKEY')
    }
    return queryState
  }
  return {
    create: createQueryState,
    get: getQueryState
  }
}
